import { render, staticRenderFns } from "./AccountCompany.vue?vue&type=template&id=3da4f5dc&"
import script from "./AccountCompany.vue?vue&type=script&lang=js&"
export * from "./AccountCompany.vue?vue&type=script&lang=js&"
import style0 from "./AccountCompany.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports